type DataExportCardProps = {
  title: string
  description: string
  stateLabel: string
  stateValue: string
  expiresAtLabel: string
  expiresAtValue: string
  exportButtonLabel: string
  exportButtonBusyLabel: string
  downloadButtonLabel: string
  downloadButtonBusyLabel: string
  requesting: boolean
  downloading: boolean
  canDownload: boolean
  onRequestExport: () => void
  onDownload: () => void
}

export const DataExportCard = ({
  title,
  description,
  stateLabel,
  stateValue,
  expiresAtLabel,
  expiresAtValue,
  exportButtonLabel,
  exportButtonBusyLabel,
  downloadButtonLabel,
  downloadButtonBusyLabel,
  requesting,
  downloading,
  canDownload,
  onRequestExport,
  onDownload,
}: DataExportCardProps) => (
  <section className="ca-card-shell ca-theme-transition rounded-3xl p-5">
    <h2 className="text-sm font-semibold uppercase tracking-[0.16em] text-(--color-text-muted)">{title}</h2>
    <p className="mt-1 text-sm text-(--color-text-secondary)">{description}</p>
    <div className="mt-4 space-y-2 text-sm">
      <div className="flex items-center justify-between gap-4">
        <span className="text-(--color-text-muted)">{stateLabel}</span>
        <span className="font-semibold text-(--color-text-primary)">{stateValue}</span>
      </div>
      <div className="flex items-center justify-between gap-4">
        <span className="text-(--color-text-muted)">{expiresAtLabel}</span>
        <span className="font-semibold text-(--color-text-primary)">{expiresAtValue}</span>
      </div>
    </div>
    <div className="mt-4 flex flex-wrap gap-2">
      <button
        type="button"
        onClick={onRequestExport}
        disabled={requesting}
        className="ca-btn-primary inline-flex h-9 items-center px-4 text-sm font-semibold disabled:cursor-not-allowed disabled:opacity-70"
      >
        {requesting ? exportButtonBusyLabel : exportButtonLabel}
      </button>
      <button
        type="button"
        onClick={onDownload}
        disabled={!canDownload || downloading}
        className="ca-btn-secondary inline-flex h-9 items-center px-4 text-sm font-semibold disabled:cursor-not-allowed disabled:opacity-60"
      >
        {downloading ? downloadButtonBusyLabel : downloadButtonLabel}
      </button>
    </div>
  </section>
)
